export default "__VITE_ASSET__BVoPNVlT__"